import React, {Component} from 'react';
import UjianTugas from "./UjianTugas"
import TugasOffline from "./TugasOffline"
import { Nav, NavItem, NavLink } from 'reactstrap';
import ModalHelp from "../../../components/ModalHelp";

class Lists extends Component {
  
    constructor() {
        super()
        this.state = {
            activeTab: "Ujiantugas",
            tutorial: '',
            isModalHelpShow  : false
        }
    
        this.handleTabClick = this.handleTabClick.bind(this);
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
      }

        toggleModalHelp() {

            this.setState({tutorial : 'https://www.youtube.com/embed/dABYhzRiyos'})

            this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
        }

      handleTabClick(tabName) {
        this.setState({ activeTab: tabName })
      }



    render() {

        const { activeTab } = this.state
        // const urlParams = queryString.parse(this.props.location.search);

        return (
            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-header">UJIAN DAN TUGAS

                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <Nav tabs>
                            <NavItem>
                            <NavLink onClick={() => this.handleTabClick("Ujiantugas")} active={activeTab === "Ujiantugas"} style={{ cursor: "pointer" }}>
                                Ujian dan Tugas Online
                            </NavLink>
                            </NavItem>
                            <NavItem>
                            <NavLink onClick={() => this.handleTabClick("Tugasoffline")} active={activeTab === "Tugasoffline"} style={{ cursor: "pointer" }}>
                                Tugas Offline
                            </NavLink>
                            </NavItem>
                        </Nav>
                        <div style={{ marginTop: 20 }}>
                            {activeTab === "Ujiantugas" ? (
                            <UjianTugas {...this.props} />
                            ) : (
                            activeTab === "Tugasoffline" && <TugasOffline {...this.props} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Lists;


// WEBPACK FOOTER //
// ./src/views/Exam/Report/Lists.js